export default "//yastatic.net/s3/distribution/pythia/frontend/_/3d709e00dba6ad913304056e5dca26e8.png";